import { createAction } from 'redux-act';
// add Task action
const addTaskRequest = createAction('ADD_TASK_REQUEST', data => data);
const addTaskSuccess = createAction('ADD_TASK_SUCCESS', data => data);
const addTaskError = createAction('ADD_TASK_ERROR');

// get Task action
const getAllTaskRequest = createAction('GET_ALL_TASK_REQUEST', data => data);
const getAllTaskSuccess = createAction('GET_ALL_TASK_SUCCESS', data => data);
const getAllTaskError = createAction('GET_ALL_TASK_ERROR');

// Update Task action
const updateTaskRequest = createAction('Update_TASK_REQUEST', data => data);
const updateTaskSuccess = createAction('Update_TASK_SUCCESS', data => data);
const updateTaskError = createAction('Update_TASK_ERROR');

// Delete Task action
const deleteTaskRequest = createAction('DELETE_TASK_REQUEST', data => data);
const deleteTaskSuccess = createAction('DELETE_TASK_SUCCESS', data => data);
const deleteTaskError = createAction('DELETE_TASK_ERROR');

// add Sub Task action
const addSubTaskRequest = createAction('ADD_SUB_TASK_REQUEST', data => data);
const addSubTaskSuccess = createAction('ADD_SUB_TASK_SUCCESS', data => data);
const addSubTaskError = createAction('ADD_SUB_TASK_ERROR');

// get Sub Task action
const getAllSubTaskRequest = createAction('GET_ALL_SUB_TASK_REQUEST', data => data);
const getAllSubTaskSuccess = createAction('GET_ALL_SUB_TASK_SUCCESS', data => data);
const getAllSubTaskError = createAction('GET_ALL_SUB_TASK_ERROR');

// Update Sub Task action
const updateSubTaskRequest = createAction('Update_SUB_TASK_REQUEST', data => data);
const updateSubTaskSuccess = createAction('Update_SUB_TASK_SUCCESS', data => data);
const updateSubTaskError = createAction('Update_SUB_TASK_ERROR');

// Delete Sub Task action
const deleteSubTaskRequest = createAction('DELETE_SUB_TASK_REQUEST', data => data);
const deleteSubTaskSuccess = createAction('DELETE_SUB_TASK_SUCCESS', data => data);
const deleteSubTaskError = createAction('DELETE_SUB_TASK_ERROR');


/* Add Task Project action */
const addTaskProjectRequest = createAction('ADD_TASK_PROJECT_REQUEST', data => data);
const addTaskProjectSuccess = createAction('ADD_TASK_PROJECT_SUCCESS', data => data);
const addTaskProjectError = createAction('ADD_TASK_PROJECT_ERROR');

/* update Task Project action */
const updateTaskProjectRequest = createAction('UPDATE_TASK_PROJECT_REQUEST', data => data);
const updateTaskProjectSuccess = createAction('UPDATE_TASK_PROJECT_SUCCESS', data => data);
const updateTaskProjectError = createAction('UPDATE_TASK_PROJECT_ERROR');

/* Delete Task Project action */
const deleteTaskProjectRequest = createAction('DELETE_TASK_PROJECT_REQUEST', data => data);
const deleteTaskProjectSuccess = createAction('DELETE_TASK_PROJECT_SUCCESS', data => data);
const deleteTaskProjectError = createAction('DELETE_TASK_PROJECT_ERROR');

/* Get Task Project action */
const getTaskProjectRequest = createAction('GET_TASK_PROJECT_REQUEST', data => data);
const getTaskProjectSuccess = createAction('GET_TASK_PROJECT_SUCCESS', data => data);
const getTaskProjectError = createAction('GET_TASK_PROJECT_ERROR');

/*  Get All Task Project List action */
const getAllTaskProjectListRequest = createAction('GET_ALL_TASK_PROJECT_LIST_REQUEST', data => data);
const getAllTaskProjectListSuccess = createAction('GET_ALL_TASK_PROJECT_LIST_SUCCESS', data => data);
const getAllTaskProjectListError = createAction('GET_ALL_TASK_PROJECT_LIST_ERROR');

/*  save Time Tracking action */
const saveTimeTrackingRequest = createAction('SAVE_TIME_TRACKING_REQUEST', data => data);
const saveTimeTrackingSuccess = createAction('SAVE_TIME_TRACKING_SUCCESS', data => data);
const saveTimeTrackingError = createAction('SAVE_TIME_TRACKING_ERROR');

const getTaskLogsRequest = createAction('GET_TASK_LOGS_REQUEST', data => data);
const getTaskLogsSuccess = createAction('GET_TASK_LOGS_SUCCESS', data => data);
const getTaskLogsError = createAction('GET_TASK_LOGS_ERROR');

const taskReportRequest = createAction('TASK_REPORT_REQUEST', data => data);
const taskReportSuccess = createAction('TASK_REPORT_SUCCESS', data => data);
const taskReportError = createAction('TASK_REPORT_ERROR');

const taskStatusRequest = createAction('TASK_STATUS_REQUEST', data => data);
const taskStatusSuccess = createAction('TASK_STATUS_SUCCESS', data => data);
const taskStatusError = createAction('TASK_STATUS_ERROR');

const employeeWiseTaskRequest = createAction('EMPLOYEE_WISE_TASK_REQUEST', data => data);
const employeeWiseTaskSuccess = createAction('EMPLOYEE_WISE_TASK_SUCCESS', data => data);
const employeeWiseTaskError = createAction('EMPLOYEE_WISE_TASK_ERROR');

const taskGraphRequest = createAction('TASK_GRAPH_REQUEST', data => data);
const taskGraphSuccess = createAction('TASK_GRAPH_SUCCESS', data => data);
const taskGraphError = createAction('TASK_GRAPH_ERROR');

const changeStatusRequest = createAction('CHANGE_STATUS_REQUEST', data => data);
const changeStatusSuccess = createAction('CHANGE_STATUS_SUCCESS', data => data);
const changeStatusError = createAction('CHANGE_STATUS_ERROR');

const changeDueDateRequest = createAction('CHANGE_DUE_DATE_REQUEST', data => data);
const changeDueDateSuccess = createAction('CHANGE_DUE_DATE_SUCCESS', data => data);
const changeDueDateError = createAction('CHANGE_DUE_DATE_ERROR');

const addTaskFileRequest = createAction('ADD_TASK_FILE_REQUEST', data => data);
const addTaskFileSuccess = createAction('ADD_TASK_FILE_SUCCESS', data => data);
const addTaskFileError = createAction('ADD_TASK_FILE_ERROR');

const getTaskFileRequest = createAction('GET_TASK_FILE_REQUEST', data => data);
const getTaskFileSuccess = createAction('GET_TASK_FILE_SUCCESS', data => data);
const getTaskFileError = createAction('GET_TASK_FILE_ERROR');

const subTaskStatusRequest = createAction('SUB_TASK_STATUS_REQUEST', data => data);
const subTaskStatusSuccess = createAction('SUB_TASK_STATUS_SUCCESS', data => data);
const subTaskStatusError = createAction('SUB_TASK_STATUS_ERROR');

const getMyTaskRequest = createAction('GET_MY_TASK_REQUEST', data => data);
const getMyTaskSuccess = createAction('GET_MY_TASK_SUCCESS', data => data);
const getMyTaskError = createAction('GET_MY_TASK_ERROR');


const selectedTaskDetail = createAction("TASK_DETAIL", data => data)
// clear existing Task action
const handleClearTaskStore = createAction('HANDLE_CLEAR_TASK_STORE', data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addTaskRequest,
    addTaskSuccess,
    addTaskError,

    getAllTaskRequest,
    getAllTaskSuccess,
    getAllTaskError,

    updateTaskRequest,
    updateTaskSuccess,
    updateTaskError,

    deleteTaskRequest,
    deleteTaskSuccess,
    deleteTaskError,

    addSubTaskRequest,
    addSubTaskSuccess,
    addSubTaskError,

    getAllSubTaskRequest,
    getAllSubTaskSuccess,
    getAllSubTaskError,

    updateSubTaskRequest,
    updateSubTaskSuccess,
    updateSubTaskError,

    deleteSubTaskRequest,
    deleteSubTaskSuccess,
    deleteSubTaskError,

    addTaskProjectRequest,
    addTaskProjectSuccess,
    addTaskProjectError,

    updateTaskProjectRequest,
    updateTaskProjectSuccess,
    updateTaskProjectError,

    deleteTaskProjectRequest,
    deleteTaskProjectSuccess,
    deleteTaskProjectError,

    getTaskProjectRequest,
    getTaskProjectSuccess,
    getTaskProjectError,

    getAllTaskProjectListRequest,
    getAllTaskProjectListSuccess,
    getAllTaskProjectListError,

    saveTimeTrackingRequest,
    saveTimeTrackingSuccess,
    saveTimeTrackingError,

    getTaskLogsRequest,
    getTaskLogsSuccess,
    getTaskLogsError,

    taskReportRequest,
    taskReportSuccess,
    taskReportError,

    taskStatusRequest,
    taskStatusSuccess,
    taskStatusError,

    employeeWiseTaskRequest,
    employeeWiseTaskSuccess,
    employeeWiseTaskError,

    taskGraphRequest,
    taskGraphSuccess,
    taskGraphError,

    changeStatusRequest,
    changeStatusSuccess,
    changeStatusError,

    changeDueDateRequest,
    changeDueDateSuccess,
    changeDueDateError,

    addTaskFileRequest,
    addTaskFileSuccess,
    addTaskFileError,

    getTaskFileRequest,
    getTaskFileSuccess,
    getTaskFileError,

    subTaskStatusRequest,
    subTaskStatusSuccess,
    subTaskStatusError,

    getMyTaskRequest,
    getMyTaskSuccess,
    getMyTaskError,

    selectedTaskDetail,

    handleClearTaskStore,
    // toastMsgAction,

}